import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLazyLoadQuery, graphql, useMutation} from 'react-relay/hooks';
import TicketIcon from '../../assets/icons0/ticket-01.svg';
import CreditCardRefreshIcon from '../../assets/icons0/credit-card-refresh.svg';
import SafeIcon from '../../assets/icons0/safe.svg';
import ShoppingCartIcon from '../../assets/icons0/shopping-cart-01.svg';
import Events from './categories/Events';
import Replenishments from './categories/Replenishments';
import Subscriptions from './categories/Subscriptions';
import Purchases from './categories/Purchases';
import Wallet01Svg from '../../assets/icons0/wallet-01.svg';
import Orders from './categories/Orders';
import './Wallet.scss';
import Skeleton from '../../components/Skeleton';
import {graphqlWhoamiNextQuery} from '../../components/graphql';
import Apply from '../../components/Apply';
import {useForm} from 'react-hook-form';
import classNames from 'classnames';
import {STEM_OFFSET} from '../../constants';
import InfoCircle01Icon from '../../assets/icons0/info-circle-01.svg';
import {Link} from 'react-router-dom';
import Currency from '../../components/currency/currency';
import {ErrorBoundary} from 'react-error-boundary';

const WALLET_CATEGORIES = [
    // {
    //     name: 'events',
    //     title: <FormattedMessage defaultMessage='Events'/>,
    //     icon: <TicketIcon/>,
    // }, {
    //     name: 'subscriptions',
    //     title: <FormattedMessage defaultMessage='Subscriptions'/>,
    //     icon: <CreditCardRefreshIcon/>
    // }, {
    //     name: 'replenishments',
    //     title: <FormattedMessage defaultMessage='Replenishments'/>,
    //     icon: <SafeIcon/>
    // }, {
    //     name: 'purchases',
    //     title: <FormattedMessage defaultMessage='Purchases'/>,
    //     icon: <ShoppingCartIcon/>
    // },
    {
        name: 'orders',
        title: <FormattedMessage defaultMessage='Order'/>,
        icon: <Wallet01Svg/>
    }
]

const WalletCategoriesComponents = {
    // events: <Events category={WALLET_CATEGORIES[0]} key={WALLET_CATEGORIES[0].name}/>,
    // subscriptions: <Subscriptions category={WALLET_CATEGORIES[1]} key={WALLET_CATEGORIES[1].name}/>,
    // replenishments: <Replenishments category={WALLET_CATEGORIES[2]} key={WALLET_CATEGORIES[2].name}/>,
    // purchases: <Purchases category={WALLET_CATEGORIES[3]} key={WALLET_CATEGORIES[3].name}/>,
    orders: <Orders category={WALLET_CATEGORIES[0]} key={WALLET_CATEGORIES[0].name}/>
}

const config = {shouldValidate: true, shouldDirty: true};
const StemImpl = React.memo(({refresh, isPending, refreshedQueryOptions}) => {
    const {whoamiNext} = useLazyLoadQuery(
        graphqlWhoamiNextQuery,
        {},
        refreshedQueryOptions.options
    );
    const {register, handleSubmit, formState: {errors}, setValue} = useForm();
    const [flag, setFlag] = React.useState(false);
    const [apply, applying] = useMutation(
        graphql`
            mutation WalletTransferMutation($request: TransferRequestInput) {
                transferAmount(request: $request) {
                     hash
                }
            }
    `);
    const submit = handleSubmit(data => apply({
        variables: {request: {toLabel: data.toLabel, amount: Math.round(data.amount * STEM_OFFSET)}},
        onCompleted: () => {
            setFlag(false); 
            refresh();
        },
        onError: () => {}
    }));
    const pendingAmounts = whoamiNext?.pending?.map(tx => tx.amount / STEM_OFFSET).join(',');
    return (
        <div className={classNames({'opacity-0dot6': isPending})}>
            <div className='padding-top-2rem color-gray-500 display-flex align-items-center'>
                {whoamiNext?.balance ? whoamiNext.balance / STEM_OFFSET || 0 : 0}
                {pendingAmounts && (
                    <span className='text-xs opacity-0dot4 color-orange-500 padding-left-0dot25rem'>
                        +{pendingAmounts}
                    </span>
                )}
                <span className='text-xs padding-left-0dot25rem'>
                    /{whoamiNext.id}
                </span>
            </div>
            <div className='padding-top-0dot5rem'>
                <div className='display-flex align-items-center'>
                    <div
                        className='color-gray-500 font-weight-bold cursor-pointer'
                        onClick={() => !isPending && !applying && setFlag((flag) => !flag)}
                    >
                        {flag ? 'Cancel transfer' : 'Transfer'}{applying && '...'}
                    </div>
                </div>
                {flag &&
                <form onSubmit={submit}>
                    <div className='form width-14rem'>
                        <div className='margin-top-0dot5rem'>
                            <div className='text-sm medium color-gray-700'>
                                To label
                                <span
                                    className='cursor-pointer color-primary-800'
                                    onClick={() => {
                                        setValue('toLabel', '61961d86183992456595b779', config)
                                    }}
                                >{' '}@IhorKa</span>
                                <span
                                    className='cursor-pointer color-primary-800'
                                    onClick={() => {
                                        setValue('toLabel', '623cad5514c47f501a90c577', config)
                                    }}
                                >{' '}@Ira_llk</span>
                                <span
                                    className='cursor-pointer color-primary-800'
                                    onClick={() => {
                                        setValue('toLabel', '616d6faa56ad07763a191c3e', config)
                                    }}
                                >{' '}@krolitska</span>
                                <span
                                    className='cursor-pointer color-primary-800'
                                    onClick={() => {
                                        setValue('toLabel', '60c8d7f1e53fd05f43ee3022', config)
                                    }}
                                >{' '}@evtimchenko</span>
                                <span
                                    className='cursor-pointer color-primary-800'
                                    onClick={() => {
                                        setValue('toLabel', '5b340edf5e97174558fcd7df', config)
                                    }}
                                >{' '}@mpls1</span>
                            </div>
                            <div className='margin-top-0dot375rem'>
                                <div className={classNames('border-1px-solid border-color-gray-300 border-radius-0dot5rem display-flex align-items-center input', {
                                    errors: errors.toLabel
                                })}>
                                    <div className='flex-1 padding-0dot875rem'>
                                        <input
                                            className='width-100percent text-md color-gray-500 background-color-gray-25'
                                            {...register('toLabel', {required: true})}
                                        />
                                    </div>
                                </div>
                                {errors.toLabel && <div className='color-error-500 margin-top-0dot375rem text-sm'><FormattedMessage defaultMessage='This field is required'/></div>}
                            </div>
                        </div>
                        <div className='margin-top-0dot5rem'>
                            <div className='text-sm medium color-gray-700'>
                                Amount
                            </div>
                            <div className='margin-top-0dot375rem'>
                                <div className={classNames('border-1px-solid border-color-gray-300 border-radius-0dot5rem display-flex align-items-center input', {
                                    errors: errors.amount
                                })}>
                                    <div className='flex-1 padding-0dot875rem'>
                                        <input
                                            className='width-100percent text-md color-gray-500 background-color-gray-25'
                                            {...register('amount', {required: true, pattern: /^\d+(?:[.]\d{1,2})*$/})}
                                        />
                                    </div>
                                </div>
                                {errors.amount && <div className='color-error-500 margin-top-0dot375rem text-sm'><FormattedMessage defaultMessage='This field is required'/></div>}
                            </div>
                        </div>
                        <div className='margin-top-0dot5rem display-flex'>
                            <div
                                className='button color-gray-500 primary font-weight-bold cursor-pointer'
                                onClick={() => !applying && submit()}
                            >
                                Go{applying && '...'}
                            </div>
                        </div>
                    </div>
                </form>
                }
            </div>
        </div>
    );
});

const Stem = React.memo(() => {
    const [refreshedQueryOptions, setRefreshedQueryOptions] = React.useState({
        options: {fetchKey: 0, fetchPolicy: 'network-only'}
    });
    const [isPending, startTransition] = React.useTransition();
    const refresh = React.useCallback(() => {
        startTransition(() => {
            setRefreshedQueryOptions(prev => ({
                ...prev,
                options: {
                    ...prev.options,
                    fetchKey: prev.options.fetchKey + 1
                }
            }));
        });
    }, []);
    return (
        <StemImpl {...{
            refreshedQueryOptions,
            refresh,
            isPending
        }} />
    );
});

const StamBalanceWalletPage = React.memo(() => {
    const {whoamiNext} = useLazyLoadQuery(graphqlWhoamiNextQuery);
    const balance = whoamiNext?.balance ? whoamiNext.balance / STEM_OFFSET || 0 : 0;
    const pendingAmounts = whoamiNext?.pending?.map(tx => tx.amount / STEM_OFFSET).join(',');
    return (
        <div className='display-flex flex-1 align-items-center padding-top-0dot25rem'>
            <p className='text-md color-gray-700 display-flex align-items-center'>
                <FormattedMessage defaultMessage='Accumulated'/>:
                <span className='color-gray-500 padding-right-0dot125rem'> {balance}</span>
                {pendingAmounts && (
                    <span className='text-xs opacity-0dot4 color-orange-500 padding-right-0dot125rem'>
                        +{pendingAmounts}
                    </span>
                )}
                <Currency {...{isStem: true, stemIconClasses: 'display-block width-1dot25rem height-1dot25rem'}}/>
            </p>
            <Link className='padding-left-0dot5rem'>
                <InfoCircle01Icon className='display-block width-1dot25rem height-1dot25rem'/>
            </Link>
        </div>
    )
});

const WalletPage = () => {
    const {whoamiNext} = useLazyLoadQuery(graphqlWhoamiNextQuery);
    return (
        <div className='background-color-gray-50 flex-1 display-flex flex-direction-column'>
            <div className='view mw768-padding-bottom-4rem display-flex flex-1 width-100percent flex-direction-column'>
                <div className='block display-flex padding-top-2rem background-color-gray-25 padding-bottom-2rem mw768-padding-bottom-4rem mw768-padding-top-4rem flex-direction-column'>
                    <p className='display-sm mw768-display-md semibold color-gray-900 padding-bottom-0dot25rem mw768-padding-bottom-0dot5rem'>
                        <FormattedMessage defaultMessage='Wallet'/>
                    </p>
                    <p className='text-lg color-gray-500'>
                        {whoamiNext.username || whoamiNext.email}
                    </p>
                    <Apply {...{on: 'stem'}}>
                        <ErrorBoundary>
                            <StamBalanceWalletPage/>
                        </ErrorBoundary>
                    </Apply>
                    <Apply {...{on: 'next'}}><Stem/></Apply>
                </div>
                <div className='block padding-top-2rem mw768-padding-top-4rem padding-bottom-0dot5rem mw768-padding-bottom-1rem'>
                    <React.Suspense fallback={<Skeleton/>}>
                        {WALLET_CATEGORIES.map((category) => (
                            WalletCategoriesComponents[category.name]
                        ))}
                    </React.Suspense>
                </div>
            </div>
       </div>
    )
}

export default React.memo(WalletPage);